import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/core/api/api.service";
import { ADMIN_ORDERS_ENDPOINTS } from "src/app/core/api/endpoints/admin-orders.endpoints";
import { NOTIFICATIONS_ENDPOINTS } from "src/app/core/api/endpoints/notifications.endpoints";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private api = inject(ApiService);

  getNotificationListHeader(params?): Observable<any> {
    return this.api.get(NOTIFICATIONS_ENDPOINTS.V1.LIST_NOTIFICATION , {params: params});
  }

  toggleNotification(id): Observable<any> {
    return this.api.get(NOTIFICATIONS_ENDPOINTS.V1.TOGGLE_READ_NOTIFICATION(id));
  }

  getFilterIcons(): Observable<any> {
    return this.api.get(NOTIFICATIONS_ENDPOINTS.V1.NOTIFICATION_TYPE_LIST);
  }
}
